import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import type { Observable } from 'rxjs';
import { MailExtractionResult, MailProcessing } from '../db/MailExtractionResult.js';
import { MailProcessingFilter } from '../db/MailProcessingFilter.js';

export const subscribeMailProcessings = registerSubscription({
  type: () => [MailProcessing],
  operationName: 'subscribeMailProcessings',
  resolve: (skip: number, limit: number, filter?: MailProcessingFilter) => {
    return (gqlFields: BaseQLSelectionSet<MailExtractionResult>): Observable<MailProcessing[]> => {
      const matchFilter = filter?.getMongoMatchFilter() ?? {};
      return watchQuery<MailProcessing>(MailProcessing._collectionName, matchFilter, { skip, limit });
    };
  },
  params: [
    { type: () => Int, name: 'skip' },
    { type: () => Int, name: 'limit' },
    { type: () => MailProcessingFilter, name: 'filter' },
  ],
});
